import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  Nav,
  NavItem,
  NavLink,
  TabPane,
  TabContent,
  InputGroup,
  InputGroupAddon,
  Input,
  FormGroup,
  Button,
  Card,
  CardBody,
  CustomInput,
  Table,
  Spinner,
} from "reactstrap";
import { Link } from "react-router-dom";
import classnames from "classnames";

import {
  addVendorsModel_close,
  ClearVendors,
  getVendorData,
  RFQSelectedVendors,
  RFQSelectedAllVendors,
  getVendorsList,
  SetParams,
  addVendors,
  getRFQRequestdata,
  setMiniVendorsList,
} from "../../store/RequetForQuotation/actions";

import {getVendorsMini4List} from "../../store/SRPurchaseOrder/actions";

class AddVendorModel extends Component {
  constructor(props) {
    super(props);
    this.state = { activeTab: 1, search: "" };
  }
  componentDidMount() {
    // Extract product_ids from RFQSelectItem as array of strings
    const productIds = this.props.RFQSelectItem.map(item => String(item.product.id));
    console.log("@AddVendorModel - componentDidMount - productIds:", productIds);
    
    // Load using stored params (if any) so searches/pages are consistent
    const params = this.props.params ? this.props.params : {};
    params.product_ids = productIds;
    
    console.log("@AddVendorModel - componentDidMount - params with product_ids:", params);
    this.props.getVendorsMini4List(params, false);
  }
  componentDidUpdate(prevProps) {
    if (prevProps.vendorsMini4List !== this.props.vendorsMini4List) {
      this.props.setMiniVendorsList(this.props.vendorsMini4List);
    }
  }
  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      if (tab >= 1 && tab <= 2) {
        this.setState({
          activeTab: tab,
        });
      }
    }
  }
  autohandleSearch = (e) => {
    this.setState({
      
      search: e.target.value,
    });
    if (e.target.value === "") {
      const productIds = this.props.RFQSelectItem.map(item => String(item.product.id));
      const params = { ...(this.props.params || {}), search: "", page: 1, product_ids: productIds };
      this.props.SetParams(params);
      this.props.getVendorsMini4List(params, false, true);
    }
  };
  handleSearch = (e) => {
    if (e.key === "Enter") {
      const productIds = this.props.RFQSelectItem.map(item => String(item.product.id));
      const params = { ...(this.props.params || {}), search: e.target.value, page: 1, product_ids: productIds };
      this.props.SetParams(params);
      this.props.getVendorsMini4List(params, false, true);
    }
  };
  selectedProductAllVendors(e) {
    console.log("@AddVendorModel - Select All clicked:", e.target.checked);
    console.log("@AddVendorModel - miniVendorslist:", this.props.miniVendorslist);
    console.log("@AddVendorModel - allvendorsCheck state:", this.props.allvendorsCheck);
    this.props.RFQSelectedAllVendors(e.target.checked);
  }
  selectedProductVendors(e, vend, index) {
    console.log("@AddVendorModel - Selected vendor:", vend.name, "checked:", e.target.checked);
    this.props.RFQSelectedVendors(e.target.checked, vend, index);
  }
  submitVendors() {
    if (this.props.RFQSelectVendors.length !== 0) {
      if (this.props.AddVendorRFQId !== "0") {
        var vendor_ids = this.props.RFQSelectVendors.map((vend) => {
          return vend.id;
        });

        this.props.addVendors(
          { vendor_ids: vendor_ids, resend: 0 },
          this.props.AddVendorRFQId
        );
        this.props.getRFQRequestdata(this.props.AddVendorRFQId);
        this.props.addVendorsModel_close();
      } else {
        this.props.addVendorsModel_close();
      }
    }
  }
  handleScroll = (e) => {
    const target = e.target;
    if (target.scrollTop !== 0) {
      if (target.scrollHeight - target.scrollTop === target.clientHeight) {
        if (this.props.params.page <= this.props.params.no_of_pages) {
          this.openPage(this.props.params.page + 1);
        }
      }
    }
  };
  openPage(pageNo) {
    const productIds = this.props.RFQSelectItem.map(item => String(item.product.id));
    this.props.SetParams({
      ...this.props.params,
      page: pageNo,
      product_ids: productIds,
    });
    this.props.getVendorsMini4List(
      {
        ...this.props.params,
        page: pageNo,
        product_ids: productIds,
      },
      false
    );
  }

  render() {
    // Use miniVendorslist (with checked flags), fallback to vendorsMini4List if empty
    const displayList = this.props.miniVendorslist.length > 0 
      ? this.props.miniVendorslist 
      : this.props.vendorsMini4List;
    
    console.log("@Render - displayList source:", this.props.miniVendorslist.length > 0 ? "miniVendorslist" : "vendorsMini4List");
    console.log("@Render - displayList length:", displayList.length);
    
    return (
      <React.Fragment>
        <Modal
          isOpen={this.props.addVendorsModel}
          toggle={this.getVendorsMini4List}
          backdrop="static"
          centered
          size="lg"
        >
          <ModalHeader toggle={() => this.props.addVendorsModel_close()}>
            Vendor Details ({this.props.RFQSelectVendors.length})
          </ModalHeader>
          <ModalBody>
            <Row className="justify-content-center p-0">
              <Col md={12} className="pt-0">
                <Nav tabs className="nav-tabs-custom pt-0">
                  <NavItem>
                    <NavLink
                      onClick={() => {
                        this.toggleTab(1);
                      }}
                      className={classnames(
                        { active: this.state.activeTab === 1 },
                        "pt-3 font-weight-bold card-title-16"
                      )}
                    >
                      {/* List | <span>{this.props.vendorsCount}</span> */}
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames(
                        { active: this.state.activeTab === 2 },
                        "pt-3 font-weight-bold card-title-16"
                      )}
                    >
                      {this.state.activeTab === 2 && "Details"}
                    </NavLink>
                  </NavItem>
                </Nav>
                <TabContent activeTab={this.state.activeTab}>
                  <TabPane tabId={1}>
                    <div className="mt-2">
                      <FormGroup className="m-0">
                        <InputGroup>
                          <Input
                            type="text"
                            name="search"
                            className="form-control d-inline-block"
                            placeholder="Vendors Search"
                            validate={{ required: true }}
                            onChange={(e) => this.autohandleSearch(e)}
                            onKeyDown={(e) => this.handleSearch(e)}
                          />
                          <InputGroupAddon addonType="append">
                            <Button
                              color="light"
                              type="submit"
                              onClick={() => {
                                const productIds = this.props.RFQSelectItem.map(item => String(item.product.id));
                                const params = { ...(this.props.params || {}), search: this.state.search, page: 1, product_ids: productIds };
                                this.props.SetParams(params);
                                this.props.getVendorsMini4List(params, false, true);
                              }}
                            >
                              <i className="ri-search-line"></i>
                            </Button>
                          </InputGroupAddon>
                        </InputGroup>
                      </FormGroup>
                    </div>
                    <div>
                      <div
                        className="table-responsive mt-2"
                        onScroll={this.handleScroll}
                        style={{
                          height: "450px",
                          overflowY: "auto",
                        }}
                      >
                        <Table className="table-centered mb-0">
                          <thead className="bg-light text-center ">
                            <tr>
                              <th style={{ width: "20px" }}>
                                <CustomInput
                                  type="checkbox"
                                  name="vendorsCheck"
                                  id="vendorsCheck"
                                  checked={this.props.allvendorsCheck || false}
                                  onChange={(e) => {
                                    this.selectedProductAllVendors(e);
                                  }}
                                />
                              </th>
                              <th> Vendors Name</th>
                              <th> Vendors Locations</th>
                            </tr>
                          </thead>
                          <tbody className="text-center">
                            {displayList.length !== 0 ? (
                              <>
                                {console.log("@Render - Displaying list count:", displayList.length)}
                                {console.log("@Render - First vendor check status:", displayList[0]?.vendorsCheck)}
                                {displayList.map((vend, key) => (
                                  <tr key={key}>
                                    <td>
                                      <CustomInput
                                        type="checkbox"
                                        name="vendorsCheck"
                                        id={"vendorsCheck" + key}
                                        checked={vend.vendorsCheck}
                                        onChange={(e) => {
                                          this.selectedProductVendors(
                                            e,
                                            vend,
                                            key
                                          );
                                        }}
                                      />
                                    </td>
                                    <td>
                                      <Link
                                        to="#"
                                        onClick={() => {
                                          this.props.getVendorData(vend.id);
                                          this.toggleTab(2);
                                        }}
                                        className="text-dark"
                                      >
                                        {vend.name}
                                      </Link>
                                    </td>
                                    <td>{vend.city}</td>
                                  </tr>
                                ))}
                                {this.props.vendorsMini4Loading === true && (
                                  <tr className="text-center">
                                    <td colSpan="3">
                                      <Spinner color="primary" />
                                    </td>
                                  </tr>
                                )}
                              </>
                            ) : (
                              <>
                                {this.props.vendorsMini4Loading === true ? (
                                  <tr className="text-center">
                                    <td colSpan="3">
                                      <Spinner color="primary" />
                                    </td>
                                  </tr>
                                ) : (
                                  <tr>
                                    <td colSpan={3}>
                                      <div className="text-center">
                                        <span className="font-size-18 text-danger">
                                          Vendors not available
                                        </span>
                                      </div>
                                    </td>
                                  </tr>
                                )}
                              </>
                            )}
                          </tbody>
                        </Table>
                      </div>
                    </div>
                    <Row>
                      <Col>
                        <div className="float-right mt-2">
                          <Button
                            type="button"
                            className="btn btn-danger mr-2"
                            color="light"
                            onClick={() => {
                              this.props.ClearVendors();
                              this.props.addVendorsModel_close();
                            }}
                          >
                            Clear
                          </Button>
                          <Button
                            type="submit"
                            className="btn btn-primary "
                            color="primary"
                            disabled={
                              this.props.RFQSelectVendors.length !== 0
                                ? false
                                : true
                            }
                            onClick={() => {
                              this.submitVendors();
                            }}
                          >
                            Submit
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId={2}>
                    <Row className="justify-content-center">
                      <Col md={12}>
                        <Card>
                          <CardBody>
                            <div className="Order-panel-content">
                              <div className="list-column">
                                <ul className="list-style-two p-1">
                                  <li className="clearfix">
                                    <span className="ttl">Vendor Name:</span>
                                    <span className="dtl">
                                      {" "}
                                      {this.props.vendordata.name}
                                    </span>
                                  </li>
                                  <li className="clearfix">
                                    <span className="ttl">
                                      Vendor Location:{" "}
                                    </span>
                                    <span className="dtl">
                                      {" "}
                                      {this.props.vendordata.city}
                                    </span>
                                  </li>

                                  <li className="clearfix">
                                    <span className="ttl">
                                      Vendor Phone No:
                                    </span>
                                    <span className="dtl">
                                      {" "}
                                      {this.props.vendordata.mobile}
                                    </span>
                                  </li>
                                  <li className="clearfix">
                                    <span className="ttl">Email:</span>
                                    <span className="dtl">
                                      {" "}
                                      {this.props.vendordata.email}
                                    </span>
                                  </li>
                                  <li className="clearfix">
                                    <span className="ttl">Address:</span>
                                    <span className="dtl">
                                      {" "}
                                      {this.props.vendordata.address}
                                    </span>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>

                    <Row>
                      <Col>
                        <div className="float-right">
                          <Button
                            type="button"
                            className="btn btn-danger"
                            color="light"
                            onClick={() => {
                              this.toggleTab(1);
                            }}
                          >
                            Back
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </TabPane>
                </TabContent>
              </Col>
            </Row>
          </ModalBody>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const {
    addVendorsModel,
    vendorslist,
    vendorsCount,
    RFQSelectVendors,
    vendordata,
    params,
    AddVendorRFQId,
    dataLoading,
    miniVendorslist,
    allvendorsCheck,
    RFQSelectItem,
  } = state.RequestForQuotation;

   const {
    loading,
    vendorsMini4List,
    vendorsMini4Loading,
  } = state.SRPurchaseOrder;

  console.log("@mapStateToProps - RequestForQuotation.miniVendorslist:", miniVendorslist);
  console.log("@mapStateToProps - SRPurchaseOrder.vendorsMini4List:", vendorsMini4List);
  console.log("@mapStateToProps - allvendorsCheck:", allvendorsCheck);
  console.log("@mapStateToProps - RFQSelectVendors:", RFQSelectVendors);
  console.log("@mapStateToProps - RFQSelectItem:", RFQSelectItem);

  return {
    addVendorsModel,
    vendorslist,
    vendorsCount,
    RFQSelectVendors,
    vendordata,
    params,
    AddVendorRFQId,
    dataLoading,
    vendorsMini4List,
    vendorsMini4Loading,
    miniVendorslist,
    allvendorsCheck,
    RFQSelectItem,
  };
};

export default connect(mapStatetoProps, {
  addVendorsModel_close,
  ClearVendors,
  getVendorData,
  RFQSelectedVendors,
  RFQSelectedAllVendors,
  getVendorsMini4List,
  SetParams,
  addVendors,
  getRFQRequestdata,
  setMiniVendorsList,
})(AddVendorModel);
